module.exports = __webpack_public_path__ + "static/media/research-0.9b1ac1a1.svg";